import LoaderSuspense from './_loader-suspense.js'
import FlexPane from './_flex-pane.js'
import TabbedPane from './_tabbed-pane.js'
import ScrollPane from './_scroll-pane.js'
import AbsolutePane from './_absolute-pane.js'
import Text from './_text.js'
import YourBetView from './_your-bet-view.js'
import OpenBetsSkeleton from './_open-bets-skeleton.js'
import Tooltip from './_tooltip.js'
import ImageButton from './_image-button.js'

export default {
  name: 'OpenBetsView',
  values: {
    showLiveBets: true,
    skeletonLoader: {
      configSet: LoaderSuspense,
      configValues: {
        style: {
          container: {
            flexDirection: 'column',
          },
        },
      },
    },
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          minHeight: '100%',
        },
      },
    },
    tabs: {
      configSet: TabbedPane,
      configValues: {
        tabButtons: {
          container: {
            style: {
              flexGrow: 0,
              flexShrink: 0,
              flexBasis: '40px',
            },
          },
          selectableButton: {
            unselected: {
              style: {
                base: {
                  alignItems: 'center',
                },
              },
            },
            selected: {
              style: {
                base: {
                  alignItems: 'center',
                },
              },
            },
          },
        },
        contentContainer: {
          container: {
            style: {
              base: {
                flexDirection: 'column',
                minHeight: '85px',
              },
              innerContainer: {
                flexDirection: 'column',
              },
            },
          },
        },
      },
    },
    scrollPane: {
      configSet: ScrollPane,
      configValues: {
        direction: 'y',
      },
    },
    scrollPaneWrapper: {
      configSet: AbsolutePane,
      configValues: {
        style: {
          width: '100%',
          height: '100%',
        },
      },
    },
    enableScrolling: false,
    _mobile_enableScrolling: true,
    valuesWidth: '50px',
    emptyOpenBetsTextContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexBasis: '50px',
          flexGrow: 0,
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          padding: '8px',
        },
      },
    },
    emptyOpenBetsText: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
        style: {
          textAlign: 'center',
        },
      },
    },
    loginInvitationContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexGrow: 0,
          padding: '8px',
          flexBasis: '100px',
          justifyContent: 'center',
          alignItems: 'center',
        },
      },
    },
    loginInvitationText: {
      configSet: Text,
      configValues: {
        style: {
          textAlign: 'center',
        },
      },
    },
    allBetsContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          padding: '4px 0',
        },
      },
    },
    betContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '4px 8px',
        },
      },
    },
    betView: {
      configSet: YourBetView,
      configValues: {},
    },
    openBetsSkeleton: {
      configSet: OpenBetsSkeleton,
      configValues: {
        showTabs: false,
      },
    },
    tooltip: {
      configSet: Tooltip,
      configValues: {
        popup: {
          container: {
            style: {
              width: '250px',
              top: 'calc(100% + 16px)',
              right: 'calc(50% - 23px)',
            },
          },
          arrowhead: {
            direction: 'up',
          },
          arrowheadOffset: '220px',
        },
      },
    },
    betHistoryButton: {
      configSet: ImageButton,
      configValues: {
        innerContainer: {
          itemSpacing: '2px',
          style: {
            flexDirection: 'row-reverse',
            alignItems: 'baseline',
            flexGrow: 0,
          },
        },
        button: {
          style: {
            base: {
              flexGrow: 0,
              minWidth: '64px',
              minHeight: '40px',
              alignSelf: 'center',
              alignItems: 'center',
              _mobile_margin: '14px 0 0 0',
            },
          },
        },
        buttonLabel: {
          container: {
            flexGrow: 0,
          },
        },
        buttonIcon: {
          src: 'chevron-right',
          style: {
            minWidth: '8px',
            minHeight: '8px',
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
